<template>
    <div class="share-box">
        <shareTop />
        <div class="share-con font-28">
            <div class="share-info">
                <div class="share-time color-6">{{ info.publishTime }}</div>
                <div class="share-name flex flex-between flex-center-v">
                    <h1 class="ellipsis font-40">{{ info.name }}</h1>
                    <span class="price font-32">{{ info.salaryMin/10000 }}万-{{ info.salaryMax/10000 }}万</span>
                </div>
                <div class="share-des flex flex-wrap color-6">
                    <p><img src="@/assets/icon/icon-address@2x.png" />{{ info.city }}-{{ info.area }}</p>
                    <p><img src="@/assets/icon/icon-briefcase@2x.png" />{{ info.workExperienceStr }}</p>
                    <p><img src="@/assets/icon/icon-education@2x.png" />{{ info.eduacationRecordStr }}</p>
                </div>
            </div>
            <div class="share-line"></div>
            <div class="share-contact flex flex-center-v font-24 color-3">
                <!-- <div class="share-avatar"></div> -->
                <img :src="info.tx" class="share-avatar" alt="">
                <div class="share-contact-text">
                    <h3 class="ellipsis font-32">{{ info.xm }}<span class="font-24" v-if="info.zhiwei">/{{ info.zhiwei }}</span></h3>
                    <p class="ellipsis">{{ info.comname }}</p>
                </div>
            </div>
            <div class="share-line"></div>
            <!-- 详情文本 -->
            <div class="share-detail">
                <h3 class="share-title font-32 color-3">职位详情</h3>
                <div class="share-tag flex flex-wrap font-24 color-6">
                    <span>{{ info.workExperienceStr }}</span>
                    <span>{{ info.eduacationRecordStr }}</span>
                    <span>{{ info.jobTypeStr }}</span>
                    <span v-if="info.allHyNames">{{ info.allHyNames[0] }}</span>
                </div>
                <div class="share-text font-28 color-6">
                    <h4>职位描述</h4>
                        {{ info.jobAskfor }}
                    <br>
                    <h4>工作描述</h4>
                        {{ info.jobDuty }}
                </div>
            </div>
        </div>
        <shareBot />
    </div>
</template>

<script>
import shareTop from '@/components/shareTop.vue'
import shareBot from '@/components/shareBot.vue'
import Api from '@/request/api'
export default {
    name: 'sharePosition',
    components: {
        shareTop,
        shareBot
    },
    data() {
        return {
            id: this.$route.query.id,
            info: {}
        }
    },
    created() {
        this.getInfo()
    },
    methods: {
        async getInfo() {
            const res = await Api.getPosition(this.id)
            if (!res) return
            this.info = res
        }
    }
}
</script>

<style lang="scss" scoped>
    // $main-color: #0095DF;
</style>
